function initOpeningHours() {
  const defaultTimezone = "Europe/London";
  const timeTables = document.querySelectorAll('[data-opening-hours-init]');
  if (!timeTables.length) return;

  timeTables.forEach(root => {
    const tz = root.getAttribute('data-opening-hours-timezone') || defaultTimezone;

    const timeToMinutes = str => {
      const m = /^([01]?\d|2[0-3]):([0-5]\d)$/.exec(str || '');
      return m ? (parseInt(m[1], 10) * 60 + parseInt(m[2], 10)) : null;
    };

    const getNowParts = () => {
      let useTz = tz;
      try { new Intl.DateTimeFormat('en-GB', { timeZone: tz }); } 
      catch { useTz = defaultTimezone; }
      const fmt = new Intl.DateTimeFormat('en-GB', {
        timeZone: useTz,
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
      const parts = fmt.formatToParts(new Date());
      const map = Object.fromEntries(parts.map(p => [p.type, p.value]));
      // Note: Intl returns Mon/Tue etc. We map to 0-6 index
      const weekdayIdx = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(map.weekday);
      return {
        weekdayIdx,
        hour: parseInt(map.hour, 10),
        minute: parseInt(map.minute, 10)
      };
    };

    const dayNames = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    const rows = Array.from(root.querySelectorAll('[data-opening-hours-day]'));
    if (!rows.length) return;

    // --- NEW LOGIC: Map Rows to Days (Handles Ranges) ---
    const ordered = new Array(7);

    rows.forEach(r => {
      const rawDay = (r.getAttribute('data-opening-hours-day') || '').trim().toLowerCase();
      
      let targets = [];

      if (rawDay.includes('-')) {
        // Handle range: "monday-saturday"
        const [startDay, endDay] = rawDay.split('-');
        const sIdx = dayNames.indexOf(startDay);
        const eIdx = dayNames.indexOf(endDay);

        if (sIdx !== -1 && eIdx !== -1 && sIdx <= eIdx) {
          for (let i = sIdx; i <= eIdx; i++) {
            targets.push(i);
          }
        }
      } else {
        // Handle single day: "sunday"
        const idx = dayNames.indexOf(rawDay);
        if (idx !== -1) targets.push(idx);
      }

      // Assign this row element to the specific day indices
      targets.forEach(i => {
        ordered[i] = r;
      });
    });
    // ----------------------------------------------------

    // If any day of the week is missing a row, stop (prevents errors)
    if (ordered.some(r => !r)) {
      console.warn('[OpeningHours] Missing days in HTML structure.');
      return;
    }

    // Build the logic schedule based on the assigned rows
    const schedule = ordered.map(row => {
      const o = (row.getAttribute('data-opening-hours-open') || '').trim();
      const c = (row.getAttribute('data-opening-hours-close') || '').trim();
      const openMin = timeToMinutes(o);
      const closeMin = timeToMinutes(c);
      if (openMin == null || closeMin == null) return { open: false, openMin: 0, closeMin: 0, overnight: false };
      const overnight = openMin > closeMin;
      return { open: true, openMin, closeMin, overnight };
    });

    const evaluate = () => {
      const now = getNowParts();
      const curIdx = now.weekdayIdx;
      // Safety check if Intl fails to return valid day
      if (curIdx === -1) return;
      
      const nowMin = now.hour * 60 + now.minute;

      // Reset current day styling
      // We use a Set to avoid removing/adding class multiple times on the same row
      const uniqueRows = new Set(ordered);
      uniqueRows.forEach(r => r.removeAttribute('data-opening-hours-current-day'));

      // Highlight the current row (even if it's a grouped row)
      ordered[curIdx].setAttribute('data-opening-hours-current-day', '');

      const today = schedule[curIdx];
      const yesterday = schedule[(curIdx + 6) % 7];

      let isOpen = false;
      if (today.open) {
        if (!today.overnight) {
          isOpen = nowMin >= today.openMin && nowMin < today.closeMin;
        } else {
          isOpen = (nowMin >= today.openMin) || (nowMin < today.closeMin);
        }
      }
      // Check if we are still in yesterday's "overnight" shift
      if (!isOpen && yesterday.open && yesterday.overnight && nowMin < yesterday.closeMin) {
        isOpen = true;
      }

      // Update status on the rows
      // If Monday and Tuesday share a row, and it's Monday, that row gets 'open'
      ordered.forEach((row, idx) => {
        // Only mark the row as Open/Closed if it corresponds to the CURRENT day index
        // Otherwise, leave it as 'closed' (default state logic)
        const status = (idx === curIdx && isOpen) ? 'open' : 'closed';
        
        // If it's the current day, we force update. 
        if(idx === curIdx) {
             row.setAttribute('data-opening-hours-status', status);
        } else {
             // If it's NOT the current day, we only set it to closed 
             // IF it is not already set to open by the current day logic 
             // (This handles the shared row case)
             if(row.getAttribute('data-opening-hours-status') !== 'open') {
                 row.setAttribute('data-opening-hours-status', 'closed');
             }
        }
      });

      root.setAttribute('data-opening-hours-store-status', isOpen ? 'open' : 'closed');
    };

    evaluate();
    clearInterval(root._openingHoursTimer);
    root._openingHoursTimer = setInterval(evaluate, 60 * 1000);

    const visHandler = () => {
      if (!document.hidden) evaluate();
    };
    if (root._openingHoursVisHandler) {
      document.removeEventListener('visibilitychange', root._openingHoursVisHandler);
    }
    root._openingHoursVisHandler = visHandler;
    document.addEventListener('visibilitychange', visHandler);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initOpeningHours();
});













(function() {
  function overrideFormStyles() {
    const formEmbed = document.querySelector('shopify-forms-embed');
    
    if (formEmbed && formEmbed.shadowRoot) {
      const existingStyle = formEmbed.shadowRoot.querySelector('#custom-form-overrides');
      if (existingStyle) return;

      const style = document.createElement('style');
      style.id = 'custom-form-overrides';
      
      style.textContent = `
        /* 1. Shrunk text element sizing & forced pristine white color balance */
        ._teaserHeading_trejf_28 {
          font-size: 11px !important;
          margin-top: 0px !important;
          color: #000000 !important;
          text-transform: uppercase;
          font-weight: bold;
        }

        /* 2. Target the true HTML button element layout, padding, background, and text variables */
        button._teaserContainer_trejf_5 {
          padding: 8px 14px !important; 
          background-color: #8bc0ff !important;
          color: #000000 !important;
          
          /* Intercept and overwrite internal app theme variables locally */
          --container-background-color: #8bc0ff !important;
          --heading-text-color: #000000 !important;
        }

        /* 3. Destroy the app's structural layout padding variables */
        #app-embed, [data-layout="floating"] {
          --app-embed-padding-y: 8px !important;
          --app-embed-padding-x: 14px !important;
          padding: 8px 14px !important;
        }

        /* 4. LOCALIZED SVG OVERRIDE: Shifts close vector fill icon to clean white */
        ._formCloseButton_1684x_4 svg {
          width: 8px !important;  
          height: 8px !important; 
          fill: #000000 !important;
          --button-close-color: #000000 !important;
        }
      `;
      
      formEmbed.shadowRoot.appendChild(style);
    }
  }

  initOverride();
  function initOverride() {
    overrideFormStyles();
    const observer = new MutationObserver(overrideFormStyles);
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
